// /goodbye — shown after account deletion
// No nav chrome, no session dependency

import React from 'react';

export function GoodbyePage() {
  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={iconStyle}>
          <WaveIcon />
        </div>
        <h1 style={headingStyle}>Account deleted</h1>
        <p style={bodyStyle}>
          Your account and all associated data have been permanently removed.
          Thanks for being part of mylodic.
        </p>
        <a href="/" style={homeLinkStyle}>
          Back to home
        </a>
      </div>
    </div>
  );
}

function WaveIcon() {
  return (
    <svg width={48} height={48} viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 11.5c0-1.7 2.686-3 4-3s4 1.3 4 3-2.686 3-4 3-4-1.3-4-3z" />
      <path d="M3 7c1.5-2 3.5-3 6-3s5 1.5 6 3" />
      <path d="M3 17c1.5 2 3.5 3 6 3s5-1.5 6-3" />
    </svg>
  );
}

const containerStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  padding: 24,
  background: 'var(--bg)',
};

const cardStyle: React.CSSProperties = {
  maxWidth: 380,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 16,
  textAlign: 'center',
  padding: '40px 28px',
  borderRadius: 'var(--radius)',
  border: '1px solid var(--border)',
  background: 'var(--surface)',
};

const iconStyle: React.CSSProperties = {
  width: 72,
  height: 72,
  borderRadius: '50%',
  background: 'var(--surface2)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 4,
};

const headingStyle: React.CSSProperties = {
  fontSize: 22,
  fontWeight: 700,
  letterSpacing: '-0.02em',
};

const bodyStyle: React.CSSProperties = {
  fontSize: 14,
  color: 'var(--text-muted)',
  lineHeight: 1.65,
  maxWidth: 300,
};

const homeLinkStyle: React.CSSProperties = {
  marginTop: 8,
  padding: '10px 24px',
  borderRadius: 100,
  background: 'var(--surface2)',
  color: 'var(--text)',
  fontSize: 14,
  fontWeight: 600,
  textDecoration: 'none',
};
